import React from "react";
import CameraContainer from "./CameraContainer";
import ImageSquare from "./ImageSquare";
import HorizontalGallery from "./HorizontalGallery";

const GALLERY_IMAGE_SIZE = 75;

interface ImageGalleryProps {
  thumbnails: string[];
  onGalleryItemPress: (index: number) => void;
  onCameraClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ImageGallery = (props: ImageGalleryProps) => {
  const { thumbnails, onGalleryItemPress, onCameraClick } = props;
  const images = () => {
    return thumbnails.map((thumbnail, index) => (
      <div key={`${thumbnail}-${index}`} style={styles.inline}>
        <ImageSquare
          size={GALLERY_IMAGE_SIZE}
          onClick={() => onGalleryItemPress(index)}
          src={thumbnail}
          alt={thumbnail}
        />
      </div>
    ));
  };
  return (
    <HorizontalGallery>
      <CameraContainer size={GALLERY_IMAGE_SIZE} onClick={onCameraClick} />
      <>{images()}</>
    </HorizontalGallery>
  );
};

const styles = {
  inline: {
    display: "inline-block",
    marginLeft: "1rem",
  },
};

export default ImageGallery;
